import { Box, Button, Tooltip, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import addIcon from "../../assets/icons/add-plus.png";

export const AddAsTemplateButton = ({ handleAddAsTemplate }) => {
	const { t } = useTranslation();

	return (
		<Tooltip
			title={
				<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
					{t("add_as_template")}
				</Typography>
			}
			placement="top"
		>
			<Button
				tooltipText={t("copy_offer_to_fields_above")}
				color="error"
				variant="text"
				onClick={handleAddAsTemplate}
				sx={{
					width: "auto",
					minWidth: "unset",
					background: "transparent",
					"&:hover": {
						background: "transparent",
					},
					py: 0,
					px: "3px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
						height: "15px",
						width: "15px",
					}}
				>
					<img
						src={addIcon}
						alt=""
						style={{
							width: "100%",
							height: "100%",
							objectFit: "contain",
						}}
					/>
				</Box>
			</Button>
		</Tooltip>
	);
};
